import { useState } from "react";
import { subscriptionService, taskService } from "@miplatform/api";
import { ENTITY_TYPES, HTTP_STATUSES } from "@miplatform/constants";
import { useDocumentsViewModel } from "@miplatform/view-models";

export const useHomeDocumentsDrawerViewModel = ({
  search = "",
  documents = [],
}) => {
  const {
    loading,
    uploadDocument,
    removeDocument,
    getDocumentCategories,
    downloadFile,
    printFile,
  } = useDocumentsViewModel();
  const [documentCategoryOptions, setDocumentCategoryOptions] = useState([]);
  const [orderTemplates, setOrderTemplates] = useState([]);
  const [trades, setTrades] = useState([]);

  const filteredDocuments = documents.filter((doc) => {
    return doc.name.toLowerCase().includes(search.toLowerCase());
  });

  const getDocumentCategoryOptions = async () => {
    const categories = await getDocumentCategories(ENTITY_TYPES.HOME);
    if (categories) {
      const options = categories.map((category) => ({
        ...category,
        label: category.name,
        value: category.name,
      }));

      setDocumentCategoryOptions(options);
    }
  };
  const getOrderTemplates = async () => {
    const response = await taskService.orderTemplates.getAll({
      sort: "name asc",
    });

    if (response.status === HTTP_STATUSES.OK) {
      const orderTemplatesWithNone = [
        { label: "None", value: "None" },
        ...response.data.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        })),
      ];
      setOrderTemplates(orderTemplatesWithNone);
    }
  };

  const getTrades = async () => {
    const response = await subscriptionService.trades.getAll();
    if (response.status === HTTP_STATUSES.OK) {
      setTrades(
        response.data?.map(({ name, id }) => ({
          label: name,
          value: id,
        }))
      );
    }
  };

  return {
    loading,
    filteredDocuments,
    uploadDocument,
    removeDocument,
    getDocumentCategoryOptions,
    documentCategoryOptions,
    getOrderTemplates,
    orderTemplates,
    trades,
    getTrades,
    downloadFile,
    printFile,
  };
};
